export default function cellTemplateWithTitle (title, text, textClass = '') {
  return `<div class="${textClass} with-title" title="${title}">${text}</div>`
}
